export const getValueKeyFromMap = (map: Map<number | null, string | null>, tag: string) => {
    let keyValue: number | null = null;
    for (let [key, value] of map.entries()) {
        if (value === tag) {
            keyValue = key;
            break;
        }
    }
    return keyValue;
};

export function getStatusReconciliationModalTableHeight({ rowHeight, rows, tableMaxHeight }: { rowHeight: number; rows: number; tableMaxHeight: number; hasScroll?: boolean; hasFooter?: boolean }) {
    // table rows height + header + footer
    if (!rows) return 150;
    let currentHeightOfTable = rowHeight * rows + 84;
    return currentHeightOfTable > tableMaxHeight - 65 ? tableMaxHeight - 65 : currentHeightOfTable;
}
